import {  GET_CUSTOMER_LIST_SUCCESS } from "../constants/customers"

const authState = {
    customerList: {
        data: [],
        total: 0
    }
}

export const customerReducer = (state = authState, action) => {
    switch (action.type) {
        case GET_CUSTOMER_LIST_SUCCESS:
            return { ...state, customerListLoading: false }
        default:
            return { ...state }
    }
}